import React from 'react';
import * as R from 'ramda';
import Mention from 'quill-mention';
import { connect } from 'react-redux';
import MagicUrl from 'quill-magic-url';
import ReactQuill, { Quill as RQuill } from 'react-quill';
import PropTypes, { string, bool, number } from 'prop-types';

import 'quill-mention/dist/quill.mention.min.css';

import { LINK } from '../../utils/regexp';
import { getUsers } from '../../redux/selectors';
import { ReactQuillWrapper } from './styled-components';

const Link = RQuill.import('formats/link');

Link.sanitize = url => !url.startsWith('http') ? `https://${url}` : url;

RQuill.register('formats/link', Link);
RQuill.register('modules/mention', Mention);
RQuill.register('modules/magicUrl', MagicUrl);

const formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'list',
  'bullet',
  'indent',
  'link',
  'clean',
  'mention',
];

class ReactQuillField extends React.PureComponent {
  constructor(props) {
    super(props);

    this.allUsers = Object
      .values(this.props.users)
      .filter(({ isActivated, isDeleted, isDefault }) => isActivated && !isDeleted && !isDefault)
      .map(user => ({
        id: user._id,
        value: user.fullName,
        profileImage: user.profileImage,
      }))
      .sort((a, b) => a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1);
  }

  modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'clean'],
    ],
    mention: {
      offsetTop: 10,
      allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
      mentionDenotationChars: ['@'],
      source: (searchTerm, renderList) => {
        if (searchTerm.length === 0) {
          renderList(this.allUsers, searchTerm);
        } else {
          const matches = this.allUsers.filter(user => (
            user.value.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
          ));

          renderList(matches, searchTerm);
        }
      },
      renderItem: item => (
        `<img src="${item.profileImage}" width="35" height="35" />
        <span>${item.value}</span>`
      ),
    },
    magicUrl: {
      urlRegularExpression: LINK,
      globalRegularExpression: new RegExp(LINK, 'ig'),
      normalizeUrlOptions: {
        defaultProtocol: 'https',
        normalizeProtocol: true,
      },
    },
  }

  render() {
    const {
      value,
      width,
      theme,
      height,
      maxHeight,
      onChange,
      readOnly,
      placeholder,
      withPaddings,
      defaultValue,
      withRightIndent,
      withoutMention,
    } = this.props;

    const viewMode = R.isNil(theme);
    const modules = withoutMention ? R.omit(['mention'], this.modules) : this.modules;
    const modulesConfig = !readOnly ? modules : { toolbar: [] };

    return (
      <ReactQuillWrapper
        width={width}
        height={height}
        viewMode={viewMode}
        maxHeight={maxHeight}
        withPaddings={withPaddings}
        withRightIndent={withRightIndent}
      >
        <ReactQuill
          modules={modulesConfig}
          formats={formats}
          readOnly={readOnly}
          onChange={onChange}
          value={value || defaultValue}
          placeholder={placeholder}
        />
      </ReactQuillWrapper>
    );
  }
}

ReactQuillField.propTypes = {
  withPaddings: bool,
  withRightIndent: bool,
  width: PropTypes.string,
  theme: PropTypes.string,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  height: PropTypes.oneOfType([string, number]),
  maxHeight: PropTypes.oneOfType([string, number]),
  users: PropTypes.object,
  withoutMention: PropTypes.bool,
};

ReactQuillField.defaultProps = {
  height: 0,
  theme: null,
  maxHeight: null,
  width: 'auto',
  readOnly: false,
  placeholder: '',
  defaultValue: '',
  onChange: () => { },
  withPaddings: false,
  withRightIndent: false,
  value: '',
  users: {},
  withoutMention: false,
};

const mapStateToProps = state => ({
  users: getUsers(state),
});

export const ReactQuillWrapped = connect(mapStateToProps)(ReactQuillField);



// WEBPACK FOOTER //
// ./src/components/react-quill/index.js